import { useEffect } from 'react';
import { toast } from 'sonner';

// Tabs left open across a deploy keep running the old app, which can clash with
// the new server rules. Every few minutes (and when the tab comes back into view)
// compare the live main bundle with ours and offer a refresh when it changed.
const currentBundle = () =>
  [...document.querySelectorAll('script[src]')].map((s) => s.getAttribute('src')).find((src) => /\/static\/js\/main\.[^/]+\.js$/.test(src || ''));

const UpdateChecker = () => {
  useEffect(() => {
    const mine = currentBundle();
    if (!mine || process.env.NODE_ENV !== 'production') return undefined;
    let shown = false;
    const check = async () => {
      if (shown || document.visibilityState !== 'visible') return;
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: 'no-store' })).text();
        const live = (html.match(/\/static\/js\/main\.[^"']+\.js/) || [])[0];
        if (live && live !== mine) {
          shown = true;
          toast.info('A new version of Bridgeway is available.', {
            duration: Infinity,
            action: { label: 'Refresh', onClick: () => window.location.reload() },
          });
        }
      } catch {
        // offline; try again later
      }
    };
    const timer = setInterval(check, 5 * 60 * 1000);
    document.addEventListener('visibilitychange', check);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', check);
    };
  }, []);
  return null;
};

export default UpdateChecker;
